import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getSurveyDetail, getSurveyFormData, getSurveySectionData, submitResponseData, submitSurveyData } from '../../../store/actions/surveyFormAction'
import Section from './Section'
import { clearAllFields } from '../../../store/actions/surveyFieldDataAction'
import theme__ from '../../../../common/ThemeSettings'
import {
    getLeadFormData,
} from "../../../store/actions/leadFormAction";


const SectionWiseSurvey = () => {

    //==> States <==
    const navigate = useNavigate()
    const dispatch = useDispatch()


    const { leadFormData } = useSelector((state) => state?.survey?.leadFormData);

    const { survey_id, ss_id } = useParams();
    const { surveyFormQuestions, surveySections, surveyDetail } = useSelector((state) => state?.survey?.surveyData)
    const { surveyFieldsData } = useSelector((state) => state?.survey?.surveyFieldData)

    const [sectionWiseQuestion, setSectionWiseQuestion] = useState([])
    const [currentSection, setCurrentSection] = useState(null)
    const [lastRespondedQuestion, setLastRespondedQuestion] = useState('')
    const [currentSectionWidth, setCurrentSectionWidth] = useState(0)
    const [companyName, setCompanyName] = useState('');
    const progressBar = useRef(null)
    const [title, setTitle] = useState('')
    const [theme, setTheme] = useState(-1);
    const [themeSet, setThemeSet] = useState([]);
    const [buttonHeading, setButtonHeading] = useState('');
    const [flagotpPage, setflagotpPage] = useState(1)
    const [emailVerify, setEmailVerify] = useState(false);
    const [emailValidationTiming, setEmailValidationTiming] = useState('');
    const [subLoading, setSubLoading] = useState(false);
    //==> Functionalities <==


    useEffect(() => {
        dispatch(getLeadFormData({ survey_id }, navigate));
    }, []);

    useEffect(() => {
        if (leadFormData?.length > 0) {
            leadFormData?.forEach((item) => {
                const key = item.su_name;
                if (item.su_name === "email") {
                    const suOptions = JSON.parse(item.su_options);
                    const emailVerification = suOptions[0].emailVerification;
                    const emailValidationTime = suOptions[0].emailValidationTiming;
                    setEmailVerify(emailVerification);
                    setEmailValidationTiming(emailValidationTime);
                }
            });
        }
    }, [leadFormData]);

    //Data handling
    const getSectionClass = (target, sections, current) => {
        const progressClass = 'in-progress'
        if (!current || !target || sections.length === 0) {
            return ''
        }

        if (target === current) {
            return progressClass
        }

        let isComplete = true
        sections.some((section) => {
            if (section.id === target) {
                return true
            }
            if (section.id === current) {
                isComplete = false
            }
            return false
        })

        if (isComplete) {
            return progressClass
        }

        return ''
    }

    const calculateWidth = (target, sections, current) => {
        if (!current || !target || sections.length === 0) {
            return 0
        }

        if (target === current) {
            return ((100 / (sections.length - 1)) * currentSectionWidth)
        }

        let isComplete = true
        sections.some((section) => {
            if (section.id === target) {
                return true
            }
            if (section.id === current) {
                isComplete = false
            }
            return false
        })

        if (isComplete) {
            return (100 / (sections.length - 1))
        }

        return 0
    }

    const scrollToNextQue = (currentQue) => {
        const scrollByHeight = document.getElementById(`qusDiv_${currentQue}`).offsetHeight
        const currentScroll = window.scrollY
        window.scrollTo({
            top: currentScroll + scrollByHeight,
            behavior: 'smooth',
        })

        // let currentScroll = 0
        // const scrolling = setInterval(() => {
        //     window.scrollBy(0, 10)
        //     currentScroll += 10
        //     console.log('scrollByHeight', scrollByHeight, currentScroll)
        //     if (currentScroll >= scrollByHeight) {
        //         console.log('Clrear interval fire')
        //         clearInterval(scrolling)
        //     }
        // }, 5)

    }

    const genSerialAndResponse = (values, questionId, questionValue) => {
        let serialNo = ''
        let responseNo = ''
        sectionWiseQuestion?.forEach((section) => {
            section.questions?.forEach((question) => {
                if (values && values[section.id]) {
                    serialNo += `${question.su_question_id}#`
                    if (question.su_question_id === questionId) {
                        responseNo += `${questionValue ?? ''}#`
                    } else {
                        responseNo += `${values[section.id][question.su_question_id] ?? ''}#`
                    }
                }
            })
        })

        return { responseNo, serialNo }
    }

    const getStartCount = (sections, index) => {
        let count = 1

        sections?.some((section, i) => {
            if (i < index) {
                const questions = section.questions
                count += questions?.length
            }
            return i === index
        })

        return count
    }

    //Submit responses
    const submitResponse = (questionId, questionValue) => {
        scrollToNextQue(questionId)
        const { responseNo, serialNo } = genSerialAndResponse(surveyFieldsData, questionId, questionValue)
        const payload = {
            response: responseNo,
            serial_no: serialNo,
            current_question: questionId,
            ss_id: ss_id
        }
        setLastRespondedQuestion(questionId)
        dispatch(submitResponseData(payload))
    }

    const handleSubmitSurvey = () => {
        const { responseNo, serialNo } = genSerialAndResponse(surveyFieldsData, -1, -1)
        // Store latest survey snapshot locally for mapping after HubSpot login
        const snapshot = {
            survey_id,
            ss_id,
            response: responseNo,
            serial_no: serialNo,
            submittedAt: Date.now()
        };
        localStorage.setItem(`thankyou_ss_id`, ss_id);
        const payload = {
            response: responseNo,
            serial_no: serialNo,
            current_question: lastRespondedQuestion,
            survey_id: survey_id,
            ss_id: ss_id
        }
        dispatch(submitSurveyData(payload, navigate))
        dispatch(clearAllFields())
        setSubLoading(false)

        // Patch API for completion status if survey_id matches
        if (survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67') {
            const hs_object_id = localStorage.getItem('hs_object_id');
            if (hs_object_id) {
                fetch(`${process.env.REACT_APP_API_URL}/survey/patchAPI`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: `userId=${encodeURIComponent(hs_object_id)}&action=completion_status&value=1`
                });
            }
        }
    }


    //==> Effects <==
    useEffect(() => {
        // Start QnA with a fresh answer state on each page load/remount.
        dispatch(clearAllFields())
    }, [dispatch])

    useEffect(() => {
        let token = localStorage.getItem("customer_token")
        if (!token || !ss_id || ss_id === 'undefined' || !survey_id) {
            navigate('/')
        }
        dispatch(getSurveySectionData({
            "survey_id": survey_id
        }))
        dispatch(getSurveyFormData({
            "survey_id": survey_id
        }))

        dispatch(getSurveyDetail({
            "survey_id": survey_id
        }))

    }, [ss_id, survey_id])


    useEffect(() => {
        if (surveySections && surveyFormQuestions.length > 0) {
            let data = {}
            surveyFormQuestions?.forEach((question) => {
                const sectionId = question.su_section_id
                if (!data[sectionId]) {
                    data[sectionId] = {
                        id: sectionId,
                        name: surveySections[sectionId]?.name,
                        order: Number(surveySections[sectionId]?.order),
                        questions: [],
                        desc: surveySections[sectionId]?.desc
                    }
                }
                data[sectionId].questions.push(question)
            })

            Object.keys(data ?? {})?.forEach((section) => {
                const questions = data[section].questions
                const sortedQuestions = questions.sort((a, b) => Number(a.su_order_no ?? 0) - Number(b.su_order_no ?? 0))
                data[section].questions = sortedQuestions
            })

            let tmpData = Object.keys(data ?? {})?.map((section) => (data[section]))
            tmpData = tmpData?.sort((a, b) => a.order - b.order)

            setCurrentSection(tmpData.length > 0 && tmpData[0].id)
            setSectionWiseQuestion(tmpData);
        }
    }, [surveyFormQuestions, surveySections])


    useEffect(() => {
        if (surveyDetail.length > 0) {
            let t = JSON.parse(surveyDetail[0].su_survey_title)

            if (surveyDetail[0].questionaire_heading != '' && surveyDetail[0].questionaire_heading != null && surveyDetail[0].questionaire_heading != undefined) {
                setCompanyName([surveyDetail[0].questionaire_heading]);
                setTitle('')
            } else {
                setCompanyName([surveyDetail[0].company_name]);
                setTitle(t['22'])
            }

            if (surveyDetail[0].questionaire_button_heading != '' && surveyDetail[0].questionaire_button_heading != null && surveyDetail[0].questionaire_button_heading != undefined) {
                setButtonHeading([surveyDetail[0].questionaire_button_heading]);
            } else {
                setButtonHeading("Get your personalised recommendation");
            }
            setTheme([surveyDetail[0].theme_selected]);
        }
    }, [surveyDetail])

    useEffect(() => {
        setThemeSet(theme__[theme]);
    }, [theme]);


    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: "<style type='text/css'> :root { --font-family: " + themeSet['--font-family'] + "; --da-primary: " + themeSet['--da-primary'] + " !important; --da-secondary: " + themeSet['--da-secondary'] + " !important; --progress-1: " + themeSet['--progress-1'] + " !important; --progress-2: " + themeSet['--progress-2'] + " !important; --progress-3: " + themeSet['--progress-3'] + " !important; --progress-4: " + themeSet['--progress-4'] + " !important; --progress-5: " + themeSet['--progress-5'] + " !important; } </style>" }} />

            {(flagotpPage === 1) && (
                <>
                    <div className='banner-section-qna  new-banner'>
                        <div className="container">
                            <div className="row">
                                <div className='col-lg-12 d-flex align-items-center'>
                                    <div className="left-logo">
                                        {/* <Svg name="vodafone-logo-small" /> */}
                                    </div>
                                    <div className="text-wrap flex-grow-1 ps-0">
                                        {/* <div className="logo-wrap">
                                    <Svg name="vodafone-logo" />
                                </div> */}
                                        {/* <p><strong>Vodafone</strong> Business</p> */}
                                        {/* <h1>Vodafone Business<br /> Rapid Cloud Assessment</h1> */}
                                        <h1>{companyName} {title}</h1>
                                    </div>
                                </div>
                                {/* <div className='col-md-4 col-lg-5 image-cen'>
                            <div className="img-wrap">
                                <img src={bannerImg} alt='bannerImg' className='img-fluid' />
                            </div>
                        </div> */}
                            </div>

                        </div>
                    </div>
                    <div className="qna-section-wrap">
                        <div className="qna-progress" ref={progressBar}>
                            <div className="container">
                                <div className="prograss-wrap ">
                                    <div className="prograss-bg">
                                        {
                                            sectionWiseQuestion?.map((section, index, arr) => {
                                                if (index + 1 === arr.length)
                                                    return ''
                                                return (
                                                    <div
                                                        className="prograss-active group-1"
                                                        style={{ width: `${calculateWidth(section.id, arr, currentSection)}%` }}
                                                        key={index}
                                                    />
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="prograss-listing">
                                        <ul>
                                            {
                                                sectionWiseQuestion?.map((section, index, arr) => {
                                                    return (
                                                        <li className={`${getSectionClass(section.id, arr, currentSection)} group-${index}`} key={index}>
                                                            <div className="text-wrap">{section.name}</div>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="questions-wrapper">
                            {
                                sectionWiseQuestion?.map((section, index, arr) => {
                                    const questions = section.questions
                                    const startCount = getStartCount(arr, index)

                                    if (currentSection === section.id) {
                                        return (
                                            <Section
                                                key={section.id}
                                                survey_id={survey_id}
                                                ss_id={ss_id}
                                                sectionId={section.id}
                                                previousSection={index === 0 ? null : arr[index - 1].id}
                                                nextSection={index + 1 === arr.length ? null : arr[index + 1].id}
                                                questions={questions}
                                                setCurrentSection={setCurrentSection}
                                                name={section.name}
                                                desc={section.desc}
                                                submitResponse={submitResponse}
                                                handleSubmitSurvey={handleSubmitSurvey}
                                                setCurrentSectionWidth={setCurrentSectionWidth}
                                                startCount={startCount}
                                                progressBar={progressBar}
                                                buttonHeading={buttonHeading}
                                                emailValidationTiming={emailValidationTiming}
                                                subLoading={subLoading}
                                            />
                                        )
                                    } else {
                                        return ''
                                    }
                                })
                            }
                        </div>
                    </div >
                </>
            )}
        </>
    )
}

export default SectionWiseSurvey